
import axiosInstance from "./AxiosInstance"


// const axiosInstance = axios.create({
//     withCredentials: true,
//     baseURL: process.env.REACT_APP_BASE_URL,
// });

export function loginApi(data) {
    return axiosInstance.post(`api/auth/login`, data);
}

export function logoutApi() {
    return axiosInstance.get(`api/auth/logout`);
}

export function whoami() {
    return axiosInstance.get('api/auth/who_am_i');
}


export function signupApi(data) {
    return axiosInstance.post(`api/employee/register_employee`, data);
}

export function resendOTP(data) {
    return axiosInstance.post(`api/auth/resend_otp`, data);
}

export function verifySignupOtpApi(data) {
    return axiosInstance.put(`api/auth/register`, data);
}

export function updateUserProfilePassword(data) {
    return axiosInstance.put("api/auth/profile",data);
  }
  
  export function updateUserProfile(data) {
    return axiosInstance.patch("api/auth/profile",data);
  }
  
  export function updateUserProfilePhoto(data) {
    return axiosInstance.post("api/auth/profile",data);
  }

  export function forgotPassword(data) {
    return axiosInstance.post(`api/auth/reset_password`,data);
  }
  export function confirmforgotPassword(data) {
    return axiosInstance.post('api/auth/verify_reset_token', data);
  }
  export function enableDisableWPEmailNotification(data) {
    return axiosInstance.post('/api/auth/update_config', data);
  }
  export function verifyemail(param={}){
    const sparam=new URLSearchParams(param).toString()
    return axiosInstance.get(`api/auth/verify_email?${sparam}`)
  }